/**
 * SalvationLookupsService
 * Lookups (signed in) and the volunteer portal's anonymous settings.
 * Route: salvation/api/salvation/lookups and salvation/api/salvation/public/settings
 */
import { BaseService } from '../base/BaseService';
import { unwrapSalvationResponse as unwrap } from './unwrapSalvationResponse';
/** Salvation lookups + public settings. */
export class SalvationLookupsService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? SalvationLookupsService.DEFAULT_SERVICE_PATH,
            basePath: SalvationLookupsService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /** GET api/salvation/lookups (signed in): every lookup the console and portal need, in one call. */
    async getLookups() {
        return unwrap(await this.getLookupsRaw(), 'Salvation lookups not found');
    }
    getLookupsRaw() {
        return this.http.get(this.buildUrl('lookups'));
    }
    /** GET api/salvation/public/settings (anonymous): what the portal shows before sign-in. */
    async getPublicSettings() {
        return unwrap(await this.getPublicSettingsRaw(), 'Salvation portal settings not found');
    }
    getPublicSettingsRaw() {
        return this.http.get(this.buildUrl('public/settings'));
    }
}
SalvationLookupsService.DEFAULT_SERVICE_PATH = 'salvation';
SalvationLookupsService.BASE_PATH = 'api/salvation';
//# sourceMappingURL=SalvationLookupsService.js.map